<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M28.6703 38.3492C28.1092 38.8031 27.2944 38.7692 26.7756 38.2674C26.1554 37.6725 26.1977 36.6688 26.863 36.1247L52.8155 14.9314L51.2479 13.6203C50.7207 13.1777 49.9538 13.1749 49.4209 13.6091L21.8474 36.1247C21.182 36.6688 21.1397 37.6725 21.76 38.2674C22.2815 38.7692 23.0935 38.8031 23.6546 38.3492L23.7476 38.2759V114.715H28.7633V38.2759L28.6703 38.3492Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.6309 38.3632L54.245 18.4189C54.775 18.0073 55.5306 18.0129 56.055 18.4302L72.5597 32.5412"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.9355 38.6847V114.715H82.814V43.909"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.4355 38.6057H75.3557"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.9531 40.9119H71.0888"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.2518 46.0996H37.717C39.3607 46.0996 40.6943 47.4332 40.6943 49.0769V55.4008H34.2773V49.0769C34.2773 47.4332 35.6109 46.0996 37.2546 46.0996H37.2518Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.7811 62.1645H50.2463C51.89 62.1645 53.2236 63.498 53.2236 65.1418V71.4656H46.8066V65.1418C46.8066 63.498 48.1402 62.1645 49.7839 62.1645H49.7811Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.0604 78.765H62.5256C64.1693 78.765 65.5029 80.0985 65.5029 81.7422V88.0661H59.0859V81.7422C59.0859 80.0985 60.4195 78.765 62.0632 78.765H62.0604Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.0087 82.8474V88.0633H71.5918V81.9734C71.5918 80.2 73.0297 78.765 74.8003 78.765C75.6827 78.765 76.4834 79.123 77.0642 79.701"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.1777 50.7121V49.3109C59.1777 47.5375 60.6156 46.1024 62.3862 46.1024C64.1596 46.1024 65.5947 47.5403 65.5947 49.3109V55.4008H59.1777V54.0164"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.6719 82.9348V81.5336C46.6719 79.7602 48.1098 78.3251 49.8803 78.3251C51.6537 78.3251 53.0888 79.763 53.0888 81.5336V87.6235H46.6719V86.2392"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M71.3418 66.9659V65.5647C71.3418 63.7913 72.7797 62.3562 74.5503 62.3562C76.3237 62.3562 77.7587 63.7941 77.7587 65.5647V71.6545H71.3418V70.2702"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.5098 66.9292V65.528C34.5098 63.7546 35.9477 62.3195 37.7182 62.3195C39.4916 62.3195 40.9267 63.7574 40.9267 65.528V71.6178H34.5098V70.2335"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.7676 55.4008V49.3109C46.7676 47.5375 48.2055 46.1024 49.976 46.1024C51.7494 46.1024 53.1845 47.5403 53.1845 49.3109V55.4008H50.0719"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.4297 88.0267V81.9368C34.4297 80.1634 35.8676 78.7283 37.6381 78.7283C39.4115 78.7283 40.8466 80.1662 40.8466 81.9368V88.0267H37.734"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.1016 71.4431V65.3532C59.1016 63.5798 60.5394 62.1448 62.31 62.1448C64.0834 62.1448 65.5185 63.5826 65.5185 65.3532V71.4431H62.4059"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M71.3203 55.4008V49.3109C71.3203 47.5375 72.7582 46.1024 74.5288 46.1024C76.3022 46.1024 77.7372 47.5403 77.7372 49.3109V55.4008H74.6246"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.8061 94.2688H56.9028C60.7682 94.2688 63.9062 97.4068 63.9062 101.272V114.712H48.8027V101.272C48.8027 97.4068 51.9407 94.2688 55.8061 94.2688Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M56.5273 97.6859V114.444"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.5986 112.908H46.6523V114.599H65.5986V112.908Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M93.7158 80.9275V108.191C93.7158 111.146 91.3222 113.539 88.3675 113.539C85.424 113.539 83.0332 111.16 83.0191 108.219L82.6808 40.8302C82.6639 37.4893 81.178 34.3231 78.6209 32.1719L57.7631 14.0686C56.8017 13.2341 55.3779 13.2059 54.3826 14.001L47.9629 19.1379"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M89.2279 84.6604C87.9535 84.0627 86.0815 82.9434 84.5336 80.919C83.8006 79.9605 82.6334 78.438 82.4163 76.174C82.3148 75.128 82.1287 73.2024 83.4764 71.6799C84.9001 70.0729 86.9809 70.0926 87.2064 70.118C88.6161 70.2843 89.8933 71.0681 90.9111 72.0549C91.678 72.7992 92.3433 74.0003 91.7287 74.8771C91.3255 75.4523 90.4882 75.596 89.8341 75.3451C89.18 75.0914 88.6979 74.5219 88.3652 73.9044C87.3671 72.0493 87.5927 69.6528 88.774 67.9104C89.9553 66.168 91.9965 65.0882 94.0942 64.8993C97.5789 64.5864 101.182 66.8926 102.177 70.2449C103.173 73.5999 101.284 77.6091 97.9962 78.8045C97.7819 78.8834 97.5451 78.9511 97.328 78.8834C96.7895 78.7199 96.7867 77.9474 96.9897 77.423C97.6099 75.8272 99.0901 74.6769 100.706 74.1187C101.54 73.8311 102.44 73.6789 103.305 73.848C105.132 74.2033 106.274 76.0302 106.59 77.5583C106.635 77.7782 106.795 78.6382 106.502 79.89C105.631 83.6087 101.636 85.8417 101.284 86.0193C100.61 86.3548 97.2913 88.1197 95.1909 86.4056C94.4353 85.7909 93.7925 84.7337 93.9645 83.6031C94.1336 82.4923 94.9315 81.8156 95.2614 81.5365C97.5338 79.6109 101.109 80.7217 101.566 80.8711"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
